import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Loading } from './style';

// Helper to create protected route elements
export const createProtectedElement = (Component: React.ComponentType) => {
  return withAuthenticationRequired(Component, { onRedirecting: () => <Loading /> });
};
